import { diffLines } from 'diff';
import diff3Merge from 'diff3';
import { trim } from 'lodash';
import * as monacoEditor from 'monaco-editor';

const SOURCE_MARKER = '<<<<<<<< SOURCE';
const PROPOSAL_MARKER = '>>>>>>>> Proposal';
const SEPERATOR = '========';

export const doesConflictExist = (text: string) =>
  new RegExp(`(${SOURCE_MARKER}|${PROPOSAL_MARKER}|${SEPERATOR})`).test(text);

export const getConflictMonacoRanges = (
  text: string,
): monacoEditor.IRange[] => {
  const lines = text.split('\n');
  const ranges: monacoEditor.IRange[] = [];
  let start = 0;
  let end = 0;
  for (let i = 0; i < lines.length; i++) {
    if (lines[i] === SOURCE_MARKER) {
      start = i;
    } else if (lines[i] === PROPOSAL_MARKER) {
      end = i;
      // Monaco ranges are 1-indexed so we add 1 to the start and end values
      ranges.push({
        startLineNumber: start + 1,
        startColumn: 1,
        endLineNumber: end + 1,
        endColumn: (lines[end]?.length ?? 0) + 1,
      });
    }
  }
  return ranges;
};

export function generate3WayMerge(
  originalSourceSdl: string,
  updatedSourceSdl: string,
  proposalSdl: string,
): string {
  if (proposalSdl.length === 0 && updatedSourceSdl.length !== 0) {
    return `${SOURCE_MARKER}
${trim(updatedSourceSdl)}
${SEPERATOR}
${PROPOSAL_MARKER}\n`;
  }
  const originalLines = originalSourceSdl.split('\n');
  const updatedSouceLines = updatedSourceSdl.split('\n');
  const proposalLines = proposalSdl.split('\n');

  const diff = diff3Merge(updatedSouceLines, originalLines, proposalLines);

  const result = diff.reduce((acc, chunk) => {
    if (chunk.ok) {
      return acc.concat(`${chunk.ok.join('\n')}`);
    } else {
      return acc.concat(`
${SOURCE_MARKER}
${chunk?.conflict?.a.join('\n')}
${SEPERATOR}
${chunk?.conflict?.b.join('\n')}
${PROPOSAL_MARKER}\n`);
    }
  }, '');
  return result;
}

export function generate2WayMerge(
  sourceSdl: string,
  proposalSdl: string,
): string {
  const diff = diffLines(sourceSdl, proposalSdl);

  const result = diff.reduce((acc, line, index) => {
    const nextLine = index < diff.length - 1 ? diff[index + 1] : null;
    const prevLine = index < diff.length - 1 ? diff[index - 1] : null;

    if (line.removed && nextLine?.added) {
      return acc.concat(`<<<<<<<< SOURCE\n${line.value}`);
    } else if (line.added && prevLine?.removed) {
      return acc.concat(`========\n${line.value}>>>>>>>> Proposal\n`);
    } else {
      return acc.concat(line.value);
    }
  }, '');
  return result;
}
